import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Chat from "./pages/Chat";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
// Admin Pages
import AdminLayout from "./components/layouts/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminCRM from "./pages/admin/AdminCRM";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminConversations from "./pages/admin/AdminConversations";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminPayments from "./pages/admin/AdminPayments";
import AdminFiles from "./pages/admin/AdminFiles";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminCampaigns from "./pages/admin/AdminCampaigns";
import AdminTeam from "./pages/admin/AdminTeam";
import LeadDetails from "./pages/admin/LeadDetails";
// ZOEY AI Action Pages
import AICallPage from "./pages/admin/AICallPage";
import AIEmailPage from "./pages/admin/AIEmailPage";
import AITextPage from "./pages/admin/AITextPage";
import AIAppointmentPage from "./pages/admin/AIAppointmentPage";
import ImplementationPage from "./pages/admin/ImplementationPage";
import OpportunityWorkflowPage from "./pages/admin/OpportunityWorkflowPage";
import ContractsWorkflowPage from "./pages/admin/ContractsWorkflowPage";
import LeadWorkflowPage from "./pages/admin/LeadWorkflowPage";
import ManualLeadWorkflowPage from "./pages/admin/ManualLeadWorkflowPage";
import "./App.css";

// AppRouter handles the main routing logic
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (from Google OAuth)
  // This must be checked synchronously during render, not in useEffect
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route 
        path="/chat" 
        element={
          <ProtectedRoute>
            <Chat />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/chat/:conversationId" 
        element={
          <ProtectedRoute>
            <Chat />
          </ProtectedRoute>
        } 
      />
      {/* Admin Routes - with sidebar layout */}
      <Route path="/admin/login" element={<Navigate to="/login" replace />} />
      <Route path="/admin" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
      <Route path="/admin/crm" element={<AdminLayout><AdminCRM /></AdminLayout>} />
      <Route path="/admin/analytics" element={<AdminLayout><AdminAnalytics /></AdminLayout>} />
      <Route path="/admin/users" element={<AdminLayout><AdminUsers /></AdminLayout>} />
      <Route path="/admin/conversations" element={<AdminLayout><AdminConversations /></AdminLayout>} />
      <Route path="/admin/leads" element={<AdminLayout><AdminLeads /></AdminLayout>} />
      <Route path="/admin/leads/:leadId" element={<AdminLayout><LeadDetails /></AdminLayout>} />
      {/* ZOEY AI Action Pages - Full page experience */}
      <Route path="/admin/leads/:leadId/call" element={<AICallPage />} />
      <Route path="/admin/leads/:leadId/email" element={<AIEmailPage />} />
      <Route path="/admin/leads/:leadId/text" element={<AITextPage />} />
      <Route path="/admin/leads/:leadId/appointment" element={<AIAppointmentPage />} />
      <Route path="/admin/leads/:leadId/implementation" element={<ImplementationPage />} />
      <Route path="/admin/leads/:leadId/opportunity-workflow" element={<OpportunityWorkflowPage />} />
      <Route path="/admin/leads/:leadId/contracts-workflow" element={<ContractsWorkflowPage />} />
      <Route path="/admin/leads/:leadId/lead-workflow" element={<LeadWorkflowPage />} />
      <Route path="/admin/leads/:leadId/manual-workflow" element={<ManualLeadWorkflowPage />} />
      <Route path="/admin/payments" element={<AdminLayout><AdminPayments /></AdminLayout>} />
      <Route path="/admin/campaigns" element={<AdminCampaigns />} />
      <Route path="/admin/team" element={<AdminLayout><AdminTeam /></AdminLayout>} />
      <Route path="/admin/files" element={<AdminLayout><AdminFiles /></AdminLayout>} />
      <Route path="/admin/settings" element={<AdminLayout><AdminSettings /></AdminLayout>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0D0D0D]">
      <BrowserRouter>
        <AppRouter />
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#171717',
              border: '1px solid #27272A',
              color: '#EDEDED',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
